<template>
  <div class="profile-sidebar">
    <SidebarContent>
      <template #content>
        <div class="scrollable-container sidebar">
          <h1 class="underline">
              Ihr Profil
          </h1>
          <div class="subtitle">Hier sind Ihre persönlichen Kontaktdaten gespeichert. Aktuelle Infos zu Verbesserungen und Fehlerbehebungen in der App finden Sie in den Release Notes. </div>
        </div>
      </template>
      <template #actions>
        <div class="action-buttons">
          <button class="button primary tall" :disabled="saveButtonDisabled || !formValidates" @click="onSaveProfile">{{ showSaveConfirmation ? 'Gespeichert' : 'Profil speichern' }}</button>
          <!-- <button class="button ghost tall" @click="onPlan">Second important Task</button> -->
        </div>
      </template>
    </SidebarContent>
  </div>
</template>

<script>
import SidebarContent from "./SidebarContent.vue"

export default {
  name: 'ProfileSidebar',
  components: {
      SidebarContent,
  },
  props: {
  },
  data: function() {
    return {
      showSaveConfirmation: false,
      saveButtonDisabled: false
    }
  },
  methods: {
    onSaveProfile() {
      this.saveButtonDisabled = true
      this.$store.dispatch("user/saveProfile").then( () => {
        setTimeout( () => {
          this.showSaveConfirmation = true
          setTimeout( () => {
            this.showSaveConfirmation = false
            this.saveButtonDisabled = false
          }, 1000)
        }, 200)
      })
    }
  },
  computed: {
    profileChanged() {
      return this.$store.state.ui.isProfileHasChanged
    },
    profile() {
      return this.$store.getters["user/profile"]
    },
    user() {
      return this.profile.user
    },
    rev() {
      return this.profile._rev
    },
    formValidates() {
      let validationModel = this.$store.getters["ui/profileValidationModel"]
      return validationModel.validates !== false
    }
  },
}
</script>

<style scoped>
.profile-sidebar {
    display: flex;
    flex-direction: column;
    align-content: space-between;
    height: 100%;
}

.action-buttons {
  display: flex;
  flex-direction: column;
}
.action-buttons .button {
  margin-right: 30px;
}
.subtitle {
  margin-bottom: 20px;
  font-size: 18px;
  color: var(--c-deep-grey);
  letter-spacing: 0.5px;
}
</style>
